import type { GroupDetail } from 'models';
import type { ReactNode } from 'react';
import type { NavigateOptions } from 'react-router';
import { canViewAnnouncements } from 'permissions';
import type { GroupDetailScope } from '../types';

type P = {
  children: ReactNode;
  group: GroupDetail;
  navigateToGroupDetailPageByKey: ({
    id,
    key,
    navigateOptions,
  }: {
    id: string;
    key?: GroupDetailScope;
    navigateOptions?: NavigateOptions;
  }) => Promise<void>;
  scope: GroupDetailScope;
};

const GroupAnnouncementsGuard = ({ children, group, navigateToGroupDetailPageByKey, scope }: P): ReactNode => {
  const availableScopes = [
    { canView: canViewAnnouncements({ group }), scope: 'announcements' },
    { canView: true, scope: 'about' },
  ] as const;

  const canViewRequestedScope = Boolean(availableScopes.find((s) => s.scope === scope)?.canView);

  if (!canViewRequestedScope) {
    for (const availableScope of availableScopes) {
      if (availableScope.canView) {
        void navigateToGroupDetailPageByKey({
          id: group.id,
          key: availableScope.scope,
          navigateOptions: { replace: true },
        });
        return null;
      }
    }
  }

  return children;
};

export default GroupAnnouncementsGuard;
